import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';

@Component({
  moduleId: module.id,
  templateUrl: 'reset.password.component.html'
})

export class ResetPasswordComponent implements OnInit, OnDestroy {
  loading = false;
  error = '';
  success = '';

  private hasLetters = /[a-zA-Z]/;
  private hasNumbers = /\d/;
  private hasNonAlphas = /\W/;


  public resetPasswordForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(7),
      Validators.pattern(this.hasLetters),
      Validators.pattern(this.hasNumbers),
      Validators.pattern(this.hasNonAlphas)
    ]),
    confirmation: new FormControl('', Validators.required),
  }, this.passwordConfirming());

  submitted = false;
  token = null;
  private sub: any;


  passwordConfirming(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.get('confirmation').value !== control.get('password').value) {
        return {'passwordConfirming': true};
      }

      return null;
    };
  }

  constructor(private router: Router, private route: ActivatedRoute, private authenticationService: AuthenticationService) {

  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.token = params['token'];
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit({value, valid}) {
    this.submitted = true;

    if (valid) {
      this.loading = true;

      this.authenticationService.resetPassword(value.email, this.token, value.password).subscribe(result => {
        this.success = 'Awesome! Your password has been successfully set up!';
        this.loading = false;
        // setTimeout(this.router.navigate(['/login']), 3000);
      }, (e) => {
        if (typeof e.status !== 'undefined' && e.status === 400) {
          this.error = 'Invalid token. Your link is broken or expired.';
        } else {
          this.error = 'Email does not exist';
        }

        this.loading = false;
        // setTimeout(this.router.navigate(['/login']), 3000);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset.password.component.ts